import { isEmpty } from "@util/utils";

/**
 * 列表資料抓取與分頁策略 Hook
 * 僅作為 useOverview 的中繼邏輯
 * @param {object} options
 * @param {(params:object) => Promise<any>} options.fetcher - API 函式
 * @param {boolean} options.enableInfiniteScroll - 是否啟用瀑布流
 * @returns {{
 *  fetchOnce: (params:object) => Promise<{
 *    list: any[],
 *    pagination: object,
 *    extend?: object,
 *    mode: "append" | "replace"
 *  }|null>
 * }}
 */
const useListFetch = ({ fetcher, enableInfiniteScroll }) => {
	/**
	 * 將 API response 轉換為列表狀態可接受格式
	 * @param {any} resp
	 * @returns {{ list: any[], pagination: object, extend?: object } | null}
	 */
	const normalize = (resp) => {
		if (isEmpty(resp)) {
			return null;
		}

		if (Array.isArray(resp)) {
			return { list: resp, pagination: {}, extend: {} };
		}
		const {
			list = [],
			pageIndex = 1,
			pageSize = 50,
			totalCount = 0,
			totalPage = 1,
			...extend // 把其餘資料通通塞進 extend
		} = resp;

		return {
			list,
			pagination: {
				pageIndex,
				pageSize,
				totalCount,
				totalPage
			},
			extend
		};
	};

	const decideAction = (pageIndex) =>
		enableInfiniteScroll && pageIndex > 1 ? "append" : "replace";

	/**
	 * 單次取得 API 資料，並決定該用哪一種 dispatch 行為
	 * @param {object} params
	 * @returns {Promise<{ list: any[], pagination: object, extend?: object, mode: "append" | "replace" } | null>}
	 */
	const fetchOnce = async (params) => {
		const resp = await fetcher(params);
		const normalized = normalize(resp);

		if (!normalized) return null;

		const { pagination } = normalized;
		const mode = decideAction(pagination?.pageIndex ?? 1);

		return { ...normalized, mode };
	};

	return { fetchOnce };
};

export default useListFetch;
